<template>
  <el-dialog width="600px" append-to-body title="去寄样" :visible.sync="visible" :before-close="handleClose">

    <el-form class="xm-form mgt20" autoComplete="on" :model="form" v-loading="loading" :rules="formRules"
      element-loading-text="给我一点时间" label-position="right" ref="form" label-width="150px" label-suffix="：">

      <el-form-item label="邮寄地址">
        <span>{{ order.supplier_address_province }}{{ order.supplier_address_city }}{{ order.supplier_address_district
          }}{{ order.supplier_address_detail }}</span>
      </el-form-item>
      <el-form-item label="收件人姓名">
        <span>{{ order.supplier_address_name }}</span>
      </el-form-item>
      <el-form-item label="收件人电话">
        <span>{{ order.supplier_address_phone }}</span>
      </el-form-item>

      <el-form-item label="物流公司名称" prop="express_name" :show-message="false">
        <el-input type="text" style="width:350px" v-model="form.express_name" placeholder="请输入物流公司名称">
        </el-input>
      </el-form-item>
      <el-form-item label="物流编号" prop="express_no" :show-message="false">
        <el-input type="text" style="width:350px" v-model="form.express_no" placeholder="请输入物流编号">
        </el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button v-waves type="primary" @click.native.prevent="handleSetExpress" :loading="loading">确认寄样</el-button>
    </div>

  </el-dialog>
</template>

<script>
import { setExpress, getOrderDetail } from '@/api/order'

import waves from '@/directive/waves'; // 水波纹指令
export default {
  name: 'OrderExpress',
  components: {

  },
  directives: {
    waves
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    orderId: {
      type: Number,
      required: true
    },
  },
  watch: {
    visible(value) {
      if (value) {
        this.getOrderDetail();
      }
    }
  },
  created() {
    this.formatPrice = this.utils.formatPrice
  },
  data() {
    return {
      loading: false,
      order: {},
      form: {
        express_name: '',
        express_no: '',
      },
      formRules: {
        express_name: [
          { required: true, message: '请输入物流公司名称', trigger: 'blur' }
        ],
        express_no: [
          { required: true, message: '请输入物流编号', trigger: 'blur' }
        ]
      }
    };
  },
  methods: {
    getOrderDetail() {
      getOrderDetail({ id: this.orderId }).then((res) => {
        this.order = res.data.detail
      }).catch((err) => {
        console.log(err);
      })
    },
    // 寄样
    handleSetExpress() {
      // 验证form表单
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          const _form = JSON.parse(JSON.stringify(this.form));
          _form.id = this.orderId;
          setExpress(_form).then((response) => {
            this.loading = false;
            // 关闭窗口
            this.handleClose();
            // 触发父组件的callback事件
            this.$emit('getList');
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: '操作成功!'
            });
          }).catch(() => {
            this.loading = false;
          });
        }
      });
    },
    // 关闭窗口
    handleClose() {
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      // 更新visible参数
      this.$emit('update:visible', false);
    }
  }
};
</script>

<style lang="scss" scoped></style>